import Image from "next/image";
import Link from "next/link";
import React from "react";

export const BestsComparedCard = (props: {
  leftModel: string;
  rightModel: string;
  imageSrc: string;
  href: string;
}) => {
  return (
    <Link href={props.href}>
      <a>
        <article className="flex flex-col gap-5 justify-between p-3 bg-white rounded-md border border-black cursor-pointer sm:gap-8 sm:p-8">
          <h3 className="font-bold leading-tight text-center lg:text-lg">
            {props.leftModel} <br /> <span className="italic">vs</span> <br />{" "}
            {props.rightModel}
          </h3>
          <div className="flex justify-center">
            <Image
              src={props.imageSrc}
              alt={`${props.leftModel} vs ${props.rightModel}`}
              width={172}
              height={225}
            />
          </div>
        </article>
      </a>
    </Link>
  );
};
